import { useRef } from 'react'
import { Loader2 } from 'lucide-react'

interface PerPageSelectorProps {
  perPage: number
  onPerPageChange: (perPage: number) => void
  isLoading?: boolean
}

export default function PerPageSelector({ perPage, onPerPageChange, isLoading = false }: PerPageSelectorProps) {
  const triggerRef = useRef<HTMLDivElement>(null)

  const perPageOptions = [
    { value: 15, label: '15' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' }
  ]

  const currentOption = perPageOptions.find(opt => opt.value === perPage) || perPageOptions[1]

  const handlePerPageChange = (value: number) => {
    onPerPageChange(value)
    const elem = document.activeElement as HTMLElement
    elem?.blur()
  }

  return (
    <div className="dropdown dropdown-end dropdown-top">
      <div ref={triggerRef} tabIndex={0} role="button" className="btn btn-sm" aria-disabled={isLoading} data-testid="per-page-selector">
        <span className="flex items-center gap-2">
          {currentOption.label}
          {isLoading ? (
            <Loader2 className="w-3 h-3 animate-spin" />
          ) : (
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          )}
        </span>
      </div>
      <ul tabIndex={-1} className="menu menu-sm dropdown-content bg-base-100 rounded-box z-[1] mt-3 w-24 p-0 shadow">
        {perPageOptions.map((option) => (
          <li key={option.value}>
            <a
              onClick={() => !isLoading && handlePerPageChange(option.value)}
              className={`${perPage === option.value ? 'active' : ''} ${isLoading ? 'pointer-events-none opacity-50' : ''}`}
              data-testid={`per-page-option-${option.value}`}
            >
              <span className="flex-1">{option.label}</span>
              {perPage === option.value && (
                <span className="text-success">✓</span>
              )}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
